import { useQueryClient } from "@tanstack/react-query";
import { useAiChatMessageQueue } from "@/hooks/ai-chat/useAiChatMessageQueue";
import { aiChatQueryKeys } from "@/lib/data/react-query/ai-chat";
import { chatApi } from "@/lib/data/requests/ai-chat";

/** Keep accepted messages moving while the user visits other pages. */
export function ChatMessageQueueWorker({ scopeKey }: { scopeKey: string }) {
  const client = useQueryClient();
  useAiChatMessageQueue({
    scopeKey,
    api: chatApi,
    backgroundOnly: true,
    onDelivered: () => {},
    onBackgroundDelivered: () => {
      void client.invalidateQueries({ queryKey: aiChatQueryKeys.all });
    },
  });
  return null;
}
